






































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenantCatalog/common';
import Moment from 'moment';

@Component
export default class PaymentItemView extends Vue {
  public items: Common.PaymentItem[] = new Array(0);
  public params: Common.PaymentItemQuery = new Common.PaymentItemQuery();
  public exportQuery = new Common.ExportQuery('入金明細', this.params);
  public importQuery = new Common.ImportQuery('入金明細', 'PaymentItem');    
  public sortOptions: any = [{ value: 'tenantId', text: 'テナントID' },{ value: 'tenantName', text: 'テナント名称' }];
  @Prop() public tenantId:string;
  @Prop() public closingDate:Date;

  public created(){
    if (this.tenantId) this.params.tenantId = this.tenantId;
    if (this.closingDate) this.params.closingDate = this.closingDate;
    
  }
  public showBilling(tenantId:string, closingDate:Date){
      this.$router.push(String.format('/project/billing?tenantId={0}&closingDate={1}',tenantId,Moment(closingDate).format("YYYY-MM-DD")));
  }  
}
